/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DuplicateInputs */

const en_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate`)
};

const es_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicar`)
};

const fr_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dupliquer`)
};

const de_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplizieren`)
};

const ja_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製`)
};

const zh_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制`)
};

const ar_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تكرار`)
};

const id_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplikat`)
};

const it_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplica`)
};

const ru_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дублировать`)
};

const pt_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicar`)
};

const ko_duplicate = /** @type {(inputs: DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`복제`)
};

/**
* | output |
* | --- |
* | "Duplicate" |
*
* @param {DuplicateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const duplicate = /** @type {((inputs?: DuplicateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DuplicateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_duplicate(inputs)
	if (locale === "es") return es_duplicate(inputs)
	if (locale === "fr") return fr_duplicate(inputs)
	if (locale === "de") return de_duplicate(inputs)
	if (locale === "ja") return ja_duplicate(inputs)
	if (locale === "zh") return zh_duplicate(inputs)
	if (locale === "ar") return ar_duplicate(inputs)
	if (locale === "id") return id_duplicate(inputs)
	if (locale === "it") return it_duplicate(inputs)
	if (locale === "ru") return ru_duplicate(inputs)
	if (locale === "pt") return pt_duplicate(inputs)
	return ko_duplicate(inputs)
});